import * as R from 'ramda';
import React from 'react';
import {withRouter} from 'react-router-dom';

import {translate} from 'iss/strings';
import {subscribeToContractSupplierReviews} from 'iss/service/ContractSupplierReviewService';
import styles from 'iss/styles/ContractSupplierEditor.styl';
import dates from 'iss/utils/dates';
import {Button} from 'iss/widgets/Buttons';

const ContractSupplierReviewListPage = withRouter(subscribeToContractSupplierReviews(class ContractSupplierReviewListPage extends React.Component {

  getRow = (review) => {
    return <tr key={review.id} data-group-id={review.id}>
      <td className="review-grade">{review.grade}</td>
      <td className="review-additional-information">{review.additionalInformation}</td>
      <td className="review-username">{review.party.lastname + " " + review.party.firstname}</td>
      <td className="review-created">{dates.format(review.created)}</td>
    </tr>;
  };

  render() {
    return <div>
      <h1>{translate('contractSupplierReviews.title')}</h1>
      <Button id="to-supplier" text={translate('contractSupplierReviews.returnToEditor')} link={"/contract-supplier/"+this.props.supplierId} className={styles.rightFloatButton} />
      <table className="table table-striped">
        <thead>
          <tr>
            <th>{translate('domain.contractSupplierReview.grade')}</th>
            <th>{translate('domain.contractSupplierReview.additionalInformation')}</th>
            <th>{translate('domain.contractSupplierReview.party')}</th>
            <th>{translate('domain.contractSupplierReview.created')}</th>
          </tr>
        </thead>
        <tbody>
          {R.defaultTo([], this.props.reviews).map(this.getRow)}
        </tbody>

      </table>
    </div>;
  }
}));

export default ContractSupplierReviewListPage;



// WEBPACK FOOTER //
// ./modules/issFrontend/pages/ContractSupplierReviewListPage.jsx